import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { FounderBrandMark } from "../components/founder/FounderBrandMark";
import { FounderMainMenu } from "../components/founder/FounderMainMenu";
import { resolveFounderSectionIdFromPath } from "../founder/founderNavigation";

export function FounderLayout() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const selectedSectionId = resolveFounderSectionIdFromPath(location.pathname);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) {
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileMenuOpen]);

  return (
    <div className="oac-founder-app">
      <header className="oac-founder-app__header">
        <FounderBrandMark />
        <button
          aria-expanded={mobileMenuOpen}
          aria-label={mobileMenuOpen ? "Close founder menu" : "Open founder menu"}
          className="oac-founder-app__menu-toggle"
          onClick={() => setMobileMenuOpen((open) => !open)}
          type="button"
        >
          <span aria-hidden="true" className="oac-founder-app__menu-toggle-lines">
            <span />
            <span />
            <span />
          </span>
        </button>
      </header>

      <div className="oac-founder-app__frame">
        <FounderMainMenu
          mobileOpen={mobileMenuOpen}
          onCloseMobile={() => setMobileMenuOpen(false)}
          selectedSectionId={selectedSectionId}
        />

        <div className="oac-founder-app__workspace">
          <Outlet />
        </div>
      </div>

      {mobileMenuOpen ? (
        <button
          aria-label="Close founder menu"
          className="oac-founder-app__backdrop"
          onClick={() => setMobileMenuOpen(false)}
          type="button"
        />
      ) : null}
    </div>
  );
}
